import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditQuestionsComponent } from './edit-questions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';


@NgModule({
  declarations: [EditQuestionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FGBSharedModule
  ],
  exports:[EditQuestionsComponent]
})
export class EditQuestionsModule {}
